<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="400px">
    <div class="fill-height">


      <v-card class="fill-height">


        <v-card-title class="p-1 ">
          <v-chip
              label small
              class="ma-2"
              color="secondary"
          >
              ویرایش تنظیمات هزینه پیام
            DF-08-02
          </v-chip>
          <v-spacer/>
          <v-btn light icon @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-spacer/>
        <v-card-text>

          <v-form ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>



              <v-col
                  cols="12"
                  md="12"
                  sm="12">
                <v-text-field
                    dense
                    label="هزینه پیامک (ریال)"
                    outlined
                    type="number"
                    v-model="model.costAlarm"
                    :error-messages="getError('costAlarm')">
                </v-text-field>
              </v-col>

             </v-row>

            <v-divider/>
            <v-card-actions>

              <v-btn
                  color="primary"
                  class=" pr-10 pl-10"
                  type="submit"
                  block
              >
                ذخیره
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Service from "./Service";

export default {
  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,

  },
  data() {
    return {
      bindingErrors: [],
      valid: true,
    }
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value)
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors = []
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('Subscription')

    },

    save() {
      this.show1 = false
      this.bindingErrors = []
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        Service.save(this.model).then(response => {
          if (response && response.status === 200) {
            this.$snack({type: 'success'})
            this.closed()
          } else if (response && response.response.status === 400) {
            this.bindingErrors = response.response.data;
          }
        })
      }
    },

  },


}
</script>


